(function () {
  function initHero(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-slide]')); if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('[data-dot]')), name = root.querySelector('[data-hero-name]');
    var i = 0, ms = +root.dataset.interval || 5000, t;
    function show(n) {
      i = (n + slides.length) % slides.length;
      var prev = (i - 1 + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.classList.toggle('is-prev', k === prev); s.tabIndex = k === i ? 0 : -1; });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var s = slides[i];
      if (s.dataset.bg) root.style.setProperty('--hx-bg', s.dataset.bg);
      if (s.dataset.ring) root.style.setProperty('--hx-ring', s.dataset.ring);
      if (name) { name.textContent = s.dataset.name + ' →'; name.href = s.getAttribute('href'); }
    }
    function play() { clearInterval(t); if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(function () { show(i + 1); }, ms); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.dot); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(t); }); root.addEventListener('mouseleave', play);
    show(0); play();
  }
  function initReveal(scope) {
    var els = [].slice.call((scope || document).querySelectorAll('.main > .shopify-section:not(:first-child) .section, .main > .shopify-section:not(:first-child) > section'));
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { if (el.classList.contains('hx')) return; el.classList.add('reveal'); io.observe(el); });
  }
  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-hero]'), initHero); initReveal(scope); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); [].forEach.call(e.target.querySelectorAll('.reveal'), function (el) { el.classList.add('is-in'); }); });
})();